import * as React from "react";

import { AccessReportsWizardPage } from "@app/access-reports/shared";

interface PageNodeOverviewProps {
  page: AccessReportsWizardPage;
}

export const PageNodeOverview: React.FC<React.PropsWithChildren<PageNodeOverviewProps>> = (props: PageNodeOverviewProps) => {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-6">
          <label
            className="label-s mb-3"
          >
            Title
          </label>
        </div>
        <div className="col-6">
          <p
            className="copy-text-default mb-0"
          >
            {props.page.title}
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <label
            className="label-s mb-3"
          >
            Form Groups
          </label>
        </div>
        <div className="col-6">
          {props.page.formGroups.map((formGroup, formGroupIndex) => (
            <p
              className="copy-text-default mb-0"
              key={formGroupIndex}
            >
              {!!formGroup.groupPropertyId ? formGroup.groupPropertyId : formGroup.title ? formGroup.title : `Form Group ${formGroup.id + 1}`}
            </p>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
}
